const locale = require('raw-loader!../../LOCALE');

module.exports = {
    sessionStorageKey: "SPConf",
    environment: locale,
    validLanguages: ['en','fr', 'ar'],
    validContentTypes: ['movies', 'series', 'trailer']
};



// WEBPACK FOOTER //
// ./src/config/common.js